import { render } from "./chevron-right.vue?vue&type=template&id=60a74140"
import script from "./chevron-right.vue?vue&type=script&lang=js"
export * from "./chevron-right.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__